WatchSumo.MonthlyResponseTimes = class MonthlyResponseTimes extends WatchSumo.WeeklyResponseTimes {
};